import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResolutionAsignModalService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   *
   */
  public getAllStocks(): Promise<any> {
    return new Promise((resolve, reject) => {

      const headers = new HttpHeaders()
        .append('x-api-key', this.key);

      return this.http
                 .get(`${this.url}/stocks`, {responseType: 'json', headers})
                 .pipe(
                   catchError(this.errorHandler)
                 )
                 .subscribe((response: any) => {
                  resolve(response);
                }, reject);
          });
  }

  /**
   *
   */
  public getAllPurposes(): Promise<any> {
    return new Promise((resolve, reject) => {

    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/purposes`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               )
               .subscribe((response: any) => {
                resolve(response);
              }, reject);
        });
  }

  /**
   *
   */
  public getAllResolutions(stockId: number, purposeId: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('stockId'  , stockId.toString())
      .append('purposeId', purposeId.toString());

    return this.http
               .get(`${this.url}/resolutions/notRegistered`, {responseType: 'json', headers, params})
               .pipe(
                 catchError(this.errorHandler)
               );
  }
  
  /**
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error.error);
  }
}
